var map = {
	"./article-create.svg": 5530,
	"./article-ranking.svg": 5853,
	"./article.svg": 8562,
	"./change-theme.svg": 4133,
	"./dashboard.svg": 8749,
	"./example.svg": 9892,
	"./exit-fullscreen.svg": 871,
	"./eye-open.svg": 4301,
	"./eye.svg": 4986,
	"./fullscreen.svg": 6286,
	"./guide.svg": 5860,
	"./hamburger-closed.svg": 3501,
	"./hamburger-opened.svg": 6929,
	"./international.svg": 3906,
	"./introduce.svg": 6513,
	"./language.svg": 9424,
	"./link.svg": 4121,
	"./nested.svg": 1476,
	"./password.svg": 6408,
	"./permission.svg": 2561,
	"./personnel-info.svg": 3257,
	"./personnel-manage.svg": 3129,
	"./personnel.svg": 837,
	"./reward.svg": 1907,
	"./role.svg": 8622,
	"./search.svg": 2042,
	"./table.svg": 3797,
	"./tree.svg": 964,
	"./user.svg": 42
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7886;